// Contenido completo del curso "Sales First" · Club Viajemos
// Tono: cercano, motivador, emocional. Se habla de "tú".

export const MODULES = [
  { n: 0, title: "Bienvenida", subtitle: "Aquí empieza todo" },
  { n: 1, title: "La mentalidad Sales First", subtitle: "Primero las ventas" },
  { n: 2, title: "Tu estadística de ventas", subtitle: "Tu negocio en números" },
  { n: 3, title: "Tu activo más valioso: el tiempo", subtitle: "90 minutos que cambian todo" },
  { n: 4, title: "Publicita tu negocio todos los días", subtitle: "Que el mundo sepa que existes" },
  { n: 5, title: "Conviértete en una máquina de ventas", subtitle: "Mide, aprende, mejora" },
  { n: 6, title: "Tu meta y tu compromiso", subtitle: "De un sueño a una acción diaria" },
];

export const DISCLAIMER =
  "Los números son ejemplos para aprender a calcular. No son una promesa de ingresos. Tus resultados dependen de tu esfuerzo, tu constancia y tu mercado.";

export const LESSONS = [
  // ───────────────────────── MÓDULO 0 ─────────────────────────
  {
    id: "0.1",
    module: 0,
    title: "Bienvenido a Club Viajemos",
    duration: "3 min",
    tool: null,
    body: [
      { t: "p", c: "Hoy empiezas un camino que puede cambiar tu vida. En este programa vas a aprender a usar plataformas de viajes, cotizar, reservar y atender clientes. Todo eso es importante." },
      { t: "p", c: "Pero antes de la primera clase técnica queremos que entiendas algo que marca la diferencia entre quien se queda en el camino y quien construye un negocio real:" },
      { t: "quote", c: "La educación es importante. Pero lo esencial es entender que esta oportunidad se basa en pensar en SALES FIRST: primero las ventas." },
      { t: "p", c: "Este curso es corto, práctico y está diseñado para que lo apliques desde hoy, usando tu activo más valioso: tu tiempo." },
    ],
    ideaClave: "Antes de aprender una herramienta, aprende para qué la vas a usar: para vender.",
    accion: "Escribe en una hoja por qué estás aquí. ¿Qué quieres lograr con tu negocio de viajes?",
    quiz: [
      { q: "¿Qué es lo esencial en esta oportunidad?", options: ["Pensar primero en las ventas", "Aprender todas las plataformas", "Tener la mejor página web"], correct: 0, exp: "Sales First: primero las ventas. Todo lo demás se construye encima." },
      { q: "¿Cuál es tu activo más valioso?", options: ["El dinero", "El tiempo", "La computadora"], correct: 1, exp: "El tiempo bien usado es lo que produce resultados — no el dinero ni los equipos." },
      { q: "¿Para qué vas a usar las herramientas de Club Viajemos?", options: ["Para estudiar", "Para vender", "Para tenerlas guardadas"], correct: 1, exp: "Las herramientas existen para vender. Sin ventas, solo son adornos." },
    ],
  },

  // ───────────────────────── MÓDULO 1 ─────────────────────────
  {
    id: "1.1",
    module: 1,
    title: "Qué significa Sales First",
    duration: "6 min",
    tool: null,
    body: [
      { t: "p", c: "SALES FIRST significa “primero las ventas”. Es una forma de pensar y de trabajar:" },
      { t: "ul", items: [
        "Primero buscas clientes, después perfeccionas la herramienta. No esperas a “saberlo todo” para empezar a ofrecer viajes.",
        "Cada día empieza con una pregunta: “¿Con cuántas personas voy a hablar hoy sobre su próximo viaje?”",
        "Aprendes mientras vendes. Cada conversación con un cliente te enseña más que diez horas de teoría.",
        "Mides todo. Lo que se mide, se mejora.",
      ] },
    ],
    ideaClave: "Un agente que domina la plataforma pero no tiene clientes no tiene un negocio: tiene un curso terminado.",
    accion: "Escribe 10 nombres de personas que conoces y que viajan o quieren viajar.",
    quiz: [
      { q: "Sales First significa…", options: ["Primero las ventas", "Primero los cursos", "Primero la plataforma"], correct: 0, exp: "Primero las ventas: todo gira alrededor de conseguir y atender clientes." },
      { q: "¿Cuándo debes empezar a ofrecer viajes?", options: ["Cuando lo sepas todo", "Desde el primer día, aprendiendo en el camino", "Después de un año"], correct: 1, exp: "Se aprende vendiendo. Empieza hoy, aunque no lo sepas todo." },
      { q: "¿Con qué pregunta empieza tu día?", options: ["¿Con cuántas personas voy a hablar hoy?", "¿Qué clase veo hoy?", "¿Qué plataforma uso?"], correct: 0, exp: "Tu día empieza pensando en personas, no en herramientas." },
    ],
  },
  {
    id: "1.2",
    module: 1,
    title: "La educación es importante, pero no es lo esencial",
    duration: "5 min",
    tool: null,
    body: [
      { t: "p", c: "Aprender es necesario: tienes que conocer los destinos, las plataformas y cómo atender bien a un cliente. Pero la educación sola no paga las cuentas." },
      { t: "p", c: "Imagina dos agentes:" },
      { t: "ul", items: [
        "Agente A: pasa 3 meses estudiando todas las funciones de la plataforma. Habla con 5 personas. Vende 0 viajes.",
        "Agente B: estudia lo básico y empieza a hablar con 3 personas al día desde la primera semana. Se equivoca, pregunta, mejora. En 3 meses habló con más de 150 personas y ya tiene sus primeros clientes felices.",
      ] },
      { t: "p", c: "¿Cuál de los dos aprendió más? El Agente B. Porque aprendió vendiendo." },
    ],
    ideaClave: "La educación acompaña a las ventas; no las reemplaza.",
    accion: "Escríbele hoy a 3 personas de tu lista y cuéntales que ahora te dedicas a los viajes.",
    quiz: [
      { q: "¿Quién aprendió más?", options: ["El que solo estudió", "El que estudió lo básico y empezó a vender", "Los dos igual"], correct: 1, exp: "La práctica real enseña más que la teoría acumulada." },
      { q: "La educación…", options: ["acompaña a las ventas", "reemplaza a las ventas", "no sirve"], correct: 0, exp: "Es un apoyo necesario, pero no sustituye la acción de vender." },
      { q: "¿Qué te enseña más?", options: ["Leer manuales", "Hablar con clientes reales", "Ver videos todo el día"], correct: 1, exp: "Cada conversación real es una lección imposible de conseguir en un video." },
    ],
  },
  {
    id: "1.3",
    module: 1,
    title: "Las plataformas son herramientas, no resultados",
    duration: "6 min",
    tool: null,
    body: [
      { t: "p", c: "En Club Viajemos te damos acceso a plataformas poderosas: hoteles, vuelos, paquetes, tours y herramientas de marketing. Creemos en ellas, por eso te las damos. Pero somos honestos contigo:" },
      { t: "quote", c: "Una plataforma sin clientes conectados no produce un solo dólar." },
      { t: "table", head: ["Si tienes…", "Pero no tienes clientes…", "Entonces tienes…"], rows: [
        ["Una plataforma de reservas", "Nadie que reserve", "Un contrato, no un negocio"],
        ["Una página web increíble", "Nadie que la visite", "Una vitrina en una calle vacía"],
        ["Los mejores precios", "Nadie que los conozca", "Un secreto muy bien guardado"],
        ["Un auto de lujo", "Sin gasolina", "Un adorno en el garaje"],
      ] },
    ],
    ideaClave: "Lo que convierte una herramienta en ingresos es conectarle clientes todos los días.",
    accion: "Publica hoy en tu estado de WhatsApp que ahora eres agente de viajes (usa una plantilla del Módulo 4 si quieres).",
    quiz: [
      { q: "Una plataforma sin clientes es…", options: ["Un negocio", "Un contrato", "Una fuente de ingresos"], correct: 1, exp: "Sin clientes, solo tienes un contrato firmado, no un negocio vivo." },
      { q: "¿Qué convierte una herramienta en ingresos?", options: ["Tenerla instalada", "Conectarle clientes todos los días", "Pagar más por ella"], correct: 1, exp: "Los clientes son el combustible que hace producir a la herramienta." },
      { q: "Un auto de lujo sin gasolina es como…", options: ["Una plataforma sin clientes", "Un cliente sin plataforma", "Un curso sin video"], correct: 0, exp: "Hermoso, pero inmóvil. Igual que una plataforma sin clientes." },
    ],
  },

  // ───────────────────────── MÓDULO 2 ─────────────────────────
  {
    id: "2.1",
    module: 2,
    title: "El camino de un cliente",
    duration: "6 min",
    tool: null,
    body: [
      { t: "p", c: "Un negocio de viajes no se maneja con suerte: se maneja con números. Cada cliente pasa por 4 etapas:" },
      { t: "table", head: ["Etapa", "Qué significa", "Qué mides"], rows: [
        ["Contactos", "Personas a las que les hablas de viajes", "¿A cuántas les escribí o hablé?"],
        ["Conversaciones", "Las que te responden con interés", "¿Cuántas respondieron?"],
        ["Cotizaciones", "Las que te piden un precio", "¿A cuántas les envié cotización?"],
        ["Ventas", "Las que reservan y pagan", "¿Cuántas compraron?"],
      ] },
      { t: "funnel" },
    ],
    ideaClave: "Si no sabes en qué etapa pierdes clientes, no sabes qué mejorar.",
    accion: "Cuenta cuántas personas contactaste esta semana y cuántas te respondieron.",
    quiz: [
      { q: "¿Cuál es la primera etapa?", options: ["Contactos", "Ventas", "Cotizaciones"], correct: 0, exp: "Todo empieza con el contacto: hablarle a una persona de viajes." },
      { q: "Un negocio de viajes se maneja con…", options: ["Suerte", "Números", "Intuición solamente"], correct: 1, exp: "Los números te muestran la verdad y te dicen qué mejorar." },
      { q: "¿Para qué sirve medir cada etapa?", options: ["Para saber dónde pierdo clientes y mejorar", "Para llenar papeles", "No sirve"], correct: 0, exp: "Medir cada etapa revela exactamente dónde se escapan tus ventas." },
    ],
  },
  {
    id: "2.2",
    module: 2,
    title: "La fórmula de tu utilidad",
    duration: "7 min",
    tool: "utilidad",
    body: [
      { t: "p", c: "Tu ganancia del mes se calcula así:" },
      { t: "quote", c: "Utilidad del mes = Clientes cerrados × Ganancia promedio por venta\nClientes cerrados = Clientes potenciales × Tu porcentaje de cierre" },
      { t: "p", c: "Ejemplo para aprender a calcular (no es una promesa de ingresos):" },
      { t: "table", head: ["", "Mes 1", "Mes 3", "Mes 6"], rows: [
        ["Clientes potenciales al mes", "20", "40", "60"],
        ["Porcentaje de cierre", "10%", "15%", "20%"],
        ["Clientes cerrados", "2", "6", "12"],
        ["Ganancia promedio por venta", "$100", "$120", "$150"],
        ["Utilidad del mes", "$200", "$720", "$1,800"],
      ] },
      { t: "p", c: "No cambió la plataforma. Cambió el agente." },
      { t: "tool" },
    ],
    ideaClave: "Tu utilidad depende de 3 números que tú puedes mejorar.",
    accion: "Usa la calculadora con tus propios números.",
    quiz: [
      { q: "Si tienes 30 clientes potenciales y cierras el 10%, ¿cuántos clientes cierras?", options: ["30", "3", "10"], correct: 1, exp: "30 × 10% = 3 clientes cerrados." },
      { q: "Si cierras 3 clientes y ganas $100 por venta, tu utilidad es…", options: ["$300", "$100", "$30"], correct: 0, exp: "3 × $100 = $300 de utilidad." },
      { q: "Entre el mes 1 y el mes 6 del ejemplo, ¿qué cambió?", options: ["La plataforma", "El agente", "La suerte"], correct: 1, exp: "La misma plataforma, pero un agente con más clientes y mejor cierre." },
    ],
  },
  {
    id: "2.3",
    module: 2,
    title: "Las 3 formas de ganar más",
    duration: "5 min",
    tool: null,
    body: [
      { t: "p", c: "Solo hay 3 formas de aumentar tu utilidad:" },
      { t: "ol", items: [
        "Hablar con más personas (más clientes potenciales).",
        "Cerrar mejor (subir tu porcentaje de cierre con práctica y seguimiento).",
        "Vender mejor cada viaje (más noches, mejores hoteles, tours, seguros y grupos).",
      ] },
      { t: "p", c: "Las tres se mejoran con experiencia. Y la experiencia solo se consigue vendiendo." },
    ],
    ideaClave: "Cada semana elige UNA de las 3 formas y enfócate en mejorarla.",
    accion: "Elige cuál de las 3 vas a trabajar esta semana.",
    quiz: [
      { q: "¿Cuál NO es una forma de ganar más?", options: ["Hablar con más personas", "Cerrar mejor", "Esperar a que lleguen clientes solos"], correct: 2, exp: "Esperar no es una estrategia. Las ventas se salen a buscar." },
      { q: "Ofrecer un tour adicional en una reserva es…", options: ["Vender mejor cada viaje", "Prospectar", "Medir"], correct: 0, exp: "Sumar valor a cada venta aumenta tu ganancia promedio." },
      { q: "¿Cómo se mejoran las 3 formas?", options: ["Leyendo", "Con experiencia vendiendo", "Comprando otra plataforma"], correct: 1, exp: "La práctica real es la que afina cada una de las 3 formas." },
    ],
  },

  // ───────────────────────── MÓDULO 3 ─────────────────────────
  {
    id: "3.1",
    module: 3,
    title: "Vender vs. “prepararse para vender”",
    duration: "5 min",
    tool: null,
    body: [
      { t: "p", c: "No necesitas trabajar 12 horas al día. Necesitas usar bien el tiempo que tienes. La mayoría de las personas pierde semanas “preparándose”: arreglando el perfil, viendo videos, diseñando logos… y no habla con nadie." },
      { t: "p", c: "Pregúntate cada día: “Lo que estoy haciendo ahora, ¿me acerca a una venta?”" },
    ],
    ideaClave: "Prepararte es útil, pero solo vender produce ingresos.",
    accion: "Anota en qué usaste tu tiempo ayer. ¿Cuánto fue vender y cuánto fue “prepararte”?",
    quiz: [
      { q: "¿Qué produce ingresos?", options: ["Diseñar logos", "Hablar con clientes", "Ver videos"], correct: 1, exp: "Solo hablar con clientes genera ventas e ingresos." },
      { q: "La pregunta clave es…", options: ["¿Esto me acerca a una venta?", "¿Esto se ve bonito?", "¿Esto es fácil?"], correct: 0, exp: "Esa pregunta ordena tu día hacia lo que de verdad importa." },
      { q: "¿Cuántas horas necesitas trabajar?", options: ["12 horas", "Las que tengas, bien usadas", "Ninguna"], correct: 1, exp: "No se trata de más horas, sino de usar bien las que tienes." },
    ],
  },
  {
    id: "3.2",
    module: 3,
    title: "Tu rutina de 90 minutos",
    duration: "6 min",
    tool: "rutina",
    body: [
      { t: "table", head: ["Tiempo", "Actividad", "Para qué sirve"], rows: [
        ["30 min", "Prospectar: escribir a contactos nuevos, publicar en redes y estados", "Llenar tu lista de clientes potenciales"],
        ["30 min", "Dar seguimiento: responder, cotizar y volver a escribir a quien no contestó", "Convertir interés en ventas"],
        ["20 min", "Aprender: una clase o una función de la plataforma", "Crecer sin dejar de vender"],
        ["10 min", "Medir: anotar tus números en el diario de ventas", "Saber dónde mejorar"],
      ] },
      { t: "quote", c: "Regla de oro: las ventas van primero en tu día. El aprendizaje acompaña, pero no reemplaza a la prospección." },
      { t: "tool" },
    ],
    ideaClave: "90 minutos al día, todos los días, valen más que 8 horas un solo día.",
    accion: "Configura tu rutina en el planificador y cumple el primer día.",
    quiz: [
      { q: "¿Cuánto tiempo dura la rutina?", options: ["8 horas", "90 minutos", "15 minutos"], correct: 1, exp: "90 minutos enfocados: 30 + 30 + 20 + 10." },
      { q: "¿Qué va primero en tu día?", options: ["Prospectar y vender", "Aprender", "Medir"], correct: 0, exp: "Las ventas van primero; lo demás acompaña." },
      { q: "¿Qué vale más?", options: ["90 minutos todos los días", "8 horas una vez por semana", "Igual"], correct: 0, exp: "La constancia diaria vence al esfuerzo aislado." },
    ],
  },

  // ───────────────────────── MÓDULO 4 ─────────────────────────
  {
    id: "4.1",
    module: 4,
    title: "Sin publicidad, son solo contratos",
    duration: "4 min",
    tool: null,
    body: [
      { t: "p", c: "Tu plataforma solo trabaja cuando la gente sabe que existe. Si nadie sabe que vendes viajes, nadie te va a comprar, aunque tengas los mejores precios. Publicitar no es “molestar”: es avisarle a la gente que puedes ayudarla a cumplir un sueño." },
    ],
    ideaClave: "Las plataformas no sirven de nada si no las publicitas.",
    accion: "Haz una lista de los lugares donde vas a contar que vendes viajes.",
    quiz: [
      { q: "Una plataforma sin publicidad es…", options: ["Solo un contrato", "Un negocio exitoso", "Una tienda llena"], correct: 0, exp: "Sin que nadie la conozca, es solo un contrato dormido." },
      { q: "Publicitar tu negocio es…", options: ["Molestar a la gente", "Avisar que puedes ayudar a cumplir un sueño", "Innecesario"], correct: 1, exp: "Ayudas a la gente a viajar: avisarlo es un servicio, no una molestia." },
      { q: "¿Quién te compra?", options: ["Quien no te conoce", "Quien sabe que vendes viajes", "Nadie"], correct: 1, exp: "Solo te compra quien sabe que existes y a qué te dedicas." },
    ],
  },
  {
    id: "4.2",
    module: 4,
    title: "Tus 5 canales gratuitos",
    duration: "6 min",
    tool: null,
    body: [
      { t: "ol", items: [
        "Tu círculo cercano: familia, amigos, compañeros de trabajo y vecinos.",
        "Estados de WhatsApp: ofertas, destinos y fotos de clientes felices (con su permiso).",
        "Facebook e Instagram: destinos, consejos de viaje y tu historia como agente.",
        "Referidos: pide a cada cliente feliz que te recomiende a una o dos personas.",
        "Grupos y comunidades: iglesias, colegios, clubes y grupos de trabajo que viajan juntos.",
      ] },
      { t: "p", c: "Cuando ya sepas cerrar ventas, podrás sumar publicidad pagada para llegar a más personas." },
    ],
    ideaClave: "Empieza con lo que ya tienes, sin gastar dinero.",
    accion: "Publica en 2 de los 5 canales.",
    quiz: [
      { q: "¿Cuál es un canal gratuito?", options: ["Estados de WhatsApp", "Una valla publicitaria", "Un anuncio en TV"], correct: 0, exp: "Los estados de WhatsApp son gratis y llegan a toda tu agenda." },
      { q: "¿Qué le pides a un cliente feliz?", options: ["Un descuento", "Que te recomiende a 1 o 2 personas", "Nada"], correct: 1, exp: "Un cliente feliz es tu mejor publicidad: pídele referidos." },
      { q: "¿Cuándo conviene la publicidad pagada?", options: ["El primer día", "Cuando ya sabes cerrar ventas", "Nunca"], correct: 1, exp: "Primero aprende a cerrar; luego paga para llegar a más gente." },
    ],
  },
  {
    id: "4.3",
    module: 4,
    title: "Mensajes que abren conversaciones",
    duration: "5 min",
    tool: "plantillas",
    body: [
      { t: "p", c: "Usa estas plantillas listas para copiar. Un buen mensaje siempre termina con una pregunta que invita a responder." },
      { t: "tool" },
    ],
    ideaClave: "Un buen mensaje termina con una pregunta que invita a responder.",
    accion: "Envía la plantilla de círculo cercano a 5 personas.",
    quiz: [
      { q: "¿Cómo debe terminar un buen mensaje?", options: ["Con una pregunta", "Con un precio", "Sin nada"], correct: 0, exp: "Una pregunta final invita a la persona a responderte." },
      { q: "¿Qué haces si alguien no responde a una cotización?", options: ["Lo olvidas", "Le das seguimiento con amabilidad", "Le bajas el precio"], correct: 1, exp: "El seguimiento amable cierra muchas ventas que parecían perdidas." },
      { q: "¿Cuándo pides referidos?", options: ["Cuando el cliente está feliz con su viaje", "Antes de venderle", "Nunca"], correct: 0, exp: "El mejor momento para pedir referidos es cuando el cliente está feliz." },
    ],
  },

  // ───────────────────────── MÓDULO 5 ─────────────────────────
  {
    id: "5.1",
    module: 5,
    title: "El ciclo de mejora continua",
    duration: "5 min",
    tool: null,
    body: [
      { t: "p", c: "Una máquina de ventas no es alguien que nunca se equivoca. Es alguien que vende todos los días, mide sus resultados y mejora un poco cada semana:" },
      { t: "cycle" },
    ],
    ideaClave: "Pequeñas mejoras cada semana se convierten en grandes resultados.",
    accion: "Elige un día fijo de la semana para revisar tus números.",
    quiz: [
      { q: "¿Qué haces después de analizar?", options: ["Te rindes", "Aprendes y ajustas una cosa", "Cambias todo"], correct: 1, exp: "Analizas, aprendes y ajustas UNA cosa a la vez." },
      { q: "Una máquina de ventas es alguien que…", options: ["Nunca se equivoca", "Vende, mide y mejora cada semana", "Vende solo cuando tiene ganas"], correct: 1, exp: "Vender, medir y mejorar: ese es el ciclo que te hace imparable." },
      { q: "¿Cuántas cosas cambias por semana?", options: ["Una", "Todas", "Ninguna"], correct: 0, exp: "Una mejora a la vez te permite saber qué funcionó." },
    ],
  },
  {
    id: "5.2",
    module: 5,
    title: "Tu diario de ventas",
    duration: "5 min",
    tool: "diario",
    body: [
      { t: "p", c: "Al final de cada día, responde 3 preguntas:" },
      { t: "ol", items: [
        "¿Con cuántas personas hablé hoy?",
        "¿Qué funcionó hoy que debo repetir?",
        "¿Qué no funcionó y qué haré distinto mañana?",
      ] },
      { t: "tool" },
    ],
    ideaClave: "Lo que se mide, se mejora.",
    accion: "Completa tu primer registro en el diario.",
    quiz: [
      { q: "¿Cuándo llenas el diario?", options: ["Al final de cada día", "Una vez al mes", "Nunca"], correct: 0, exp: "Cada día, mientras lo recuerdas fresco." },
      { q: "¿Para qué sirve?", options: ["Para nada", "Para saber qué repetir y qué mejorar", "Para mostrarlo a otros"], correct: 1, exp: "Te muestra qué repetir y qué ajustar mañana." },
      { q: "Lo que se mide…", options: ["se mejora", "se olvida", "no importa"], correct: 0, exp: "Medir es el primer paso para mejorar." },
    ],
  },
  {
    id: "5.3",
    module: 5,
    title: "Los errores son datos",
    duration: "4 min",
    tool: null,
    body: [
      { t: "p", c: "Cada “no” te enseña algo. Tal vez el precio no era el adecuado, el destino no era el que buscaba o faltó dar seguimiento. Los errores no son fracasos: son datos que te dicen qué ajustar. Los mejores vendedores no son los que menos “no” reciben, sino los que más aprenden de cada “no”." },
    ],
    ideaClave: "Cada “no” te acerca al próximo “sí”.",
    accion: "Piensa en un cliente que no compró y escribe una cosa que harías distinto.",
    quiz: [
      { q: "Un error en ventas es…", options: ["Un fracaso", "Un dato para mejorar", "Una razón para rendirse"], correct: 1, exp: "Cada error es información valiosa para tu próxima venta." },
      { q: "Los mejores vendedores…", options: ["Nunca reciben un “no”", "Aprenden de cada “no”", "Ignoran los “no”"], correct: 1, exp: "Convierten cada “no” en una lección." },
      { q: "Cada “no” te acerca a…", options: ["El próximo “sí”", "Rendirte", "Nada"], correct: 0, exp: "Los “no” son parte del camino hacia el “sí”." },
    ],
  },

  // ───────────────────────── MÓDULO 6 ─────────────────────────
  {
    id: "6.1",
    module: 6,
    title: "Calcula tu meta al revés",
    duration: "7 min",
    tool: "meta",
    body: [
      { t: "p", c: "Empieza por cuánto quieres ganar y llega a cuántas personas debes contactar cada día:" },
      { t: "ol", items: [
        "¿Cuánto quiero ganar este mes?",
        "¿Cuánto gano en promedio por venta?",
        "Ventas necesarias = (1) ÷ (2)",
        "¿Cuál es mi porcentaje de cierre? (si empiezas, usa 10%)",
        "Clientes potenciales necesarios = (3) ÷ (4)",
        "¿Cuántos días voy a trabajar este mes?",
        "Personas por día = (5) ÷ (6)",
      ] },
      { t: "quote", c: "Ejemplo: quieres ganar $600, ganas $100 por venta y cierras el 10%: necesitas 6 ventas y 60 clientes potenciales. Trabajando 20 días, hablas con 3 personas al día. Así de alcanzable es una meta cuando la conviertes en una acción diaria." },
      { t: "tool" },
    ],
    ideaClave: "Una meta grande se logra con una acción diaria pequeña.",
    accion: "Calcula tu meta y escribe tu número diario en un lugar visible.",
    quiz: [
      { q: "Quieres ganar $400, ganas $100 por venta: ¿cuántas ventas necesitas?", options: ["2", "4", "40"], correct: 1, exp: "$400 ÷ $100 = 4 ventas." },
      { q: "Necesitas 40 clientes potenciales y trabajas 20 días: ¿con cuántas personas hablas por día?", options: ["2", "20", "40"], correct: 0, exp: "40 ÷ 20 = 2 personas por día." },
      { q: "¿Por dónde empiezas a calcular?", options: ["Por cuánto quieres ganar", "Por cuántas horas trabajas", "Por la plataforma"], correct: 0, exp: "Empiezas por tu meta de ganancia y la conviertes en acción diaria." },
    ],
  },
  {
    id: "6.2",
    module: 6,
    title: "Tu compromiso Sales First",
    duration: "4 min",
    tool: "compromiso",
    body: [
      { t: "p", c: "Lee y marca cada compromiso. Este es el pacto contigo mismo:" },
      { t: "tool" },
      { t: "quote", c: "La plataforma es el vehículo, la educación es el mapa, pero tú eres el motor. Y el combustible son tus clientes. Bienvenido a Club Viajemos: hoy empieza tu camino como máquina de ventas en la industria del turismo." },
    ],
    ideaClave: "Tú eres el motor. Tus clientes son el combustible.",
    accion: "Firma tu compromiso y escribe tu número diario de personas a contactar.",
    quiz: [
      { q: "¿Quién es el motor de tu negocio?", options: ["La plataforma", "Tú", "El curso"], correct: 1, exp: "Tú eres el motor: nada se mueve sin tu acción." },
      { q: "¿Qué es el combustible?", options: ["Tus clientes", "El dinero", "La publicidad pagada"], correct: 0, exp: "Los clientes son el combustible que hace andar todo el negocio." },
      { q: "¿Cada cuánto revisas tus resultados?", options: ["Cada año", "Cada semana", "Nunca"], correct: 1, exp: "Cada semana revisas y mejoras una cosa." },
    ],
  },
];

export const MESSAGE_TEMPLATES = [
  { label: "Para tu círculo cercano (WhatsApp)", text: "¡Hola [nombre]! 😊 Te cuento que ahora soy agente de viajes con Club Viajemos. Si estás pensando en un viaje este año, con gusto te ayudo a encontrar las mejores opciones. ¿Tienes algún destino en mente?" },
  { label: "Estado de WhatsApp", text: "✈️ ¡Nueva etapa! Ahora te ayudo a planear tus vacaciones: hoteles, vuelos, paquetes y tours. Escríbeme y te cotizo sin compromiso." },
  { label: "Seguimiento", text: "¡Hola [nombre]! ¿Pudiste revisar la cotización que te envié? Si quieres ajustamos fechas o presupuesto 😊" },
  { label: "Pedir referidos", text: "¡Qué alegría que disfrutaste tu viaje! 🙌 Si conoces a alguien que esté planeando vacaciones, me encantaría ayudarle también." },
  { label: "Publicación en redes", text: "¿Sabías que planear tu viaje con un agente puede ahorrarte tiempo y dolores de cabeza? Te ayudo a encontrar el hotel, el vuelo y los tours ideales para ti. ¡Escríbeme! ✈️" },
];

export const COMMITMENTS = [
  "Voy a hablar de viajes con al menos ___ personas cada día.",
  "Voy a anotar mis números todos los días.",
  "Voy a aprender de mis errores sin rendirme.",
  "Voy a usar la plataforma para vender, no solo para aprender.",
  "Voy a revisar mis resultados cada semana y mejorar una cosa a la vez.",
];
